import api from './api';

export const settingService = {
  getPublicSettings: ()           => api.get('/settings/public'),
  getSettings:       ()           => api.get('/settings'),
  updateSetting:     (key, value) => api.put(`/settings/${key}`, { value }),
};
